import { render, staticRenderFns } from "./StrapiEvenementCard.vue?vue&type=template&id=775695af"
import script from "./StrapiEvenementCard.vue?vue&type=script&lang=js"
export * from "./StrapiEvenementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports